import { Editor, Point } from 'slate';
import { ReactEditor } from 'slate-react';

const withHighlights = editor => {
	const { deleteBackward } = editor;

	// Color list
	const COLORS = ['highlightDefault', 'highlightRed', 'highlightYellow', 'highlightGreen'];

	// Handle's deletion event
	editor.deleteBackward = (args) => {
		// Define start point
		const start = {
			path: [0, 0],
			offset: 0,
		};

		// If cursor is at the begining of document
		// Remove all highlights
		if (Point.equals(editor.selection?.anchor, start)) {
			COLORS.forEach(mark => editor.removeMark(mark));
		}

		// Proceed with normal deletion
		deleteBackward(args);
	};

	// Check if highlight is active
	editor.isHighlightActive = highlight => {
		const marks = Editor.marks(editor) ?? {};
		return Object.keys(marks).find(color => highlight
			? color === highlight
			: COLORS.includes(color)
		);
	};

	// Toggle given highlight on selection
	editor.toggleHighlight = color => {
		// Get active highlight color
		const active = editor.isHighlightActive();

		// Remove highlight color
		editor.removeMark(active);

		// Toggle highlight color
		if (color) editor.addMark(color, true);

		// Refocus selection
		ReactEditor.focus(editor);
	};

	return editor;
};

export default withHighlights;